import { dashboardService } from '@/services/api'


const initialStates = {
    status: 'LOADING',
    data: {
        weekly_active_stores: [0, 0, 0, 0, 0, 0, 0],
        active_stores: '0',
        weekly_approved_conversions: [0, 0, 0, 0, 0, 0, 0],
        approved_conversions: '0',
        active_publishers: '0',
        weekly_actvie_publishers: [0, 0, 0, 0, 0, 0, 0]
    },
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setData(state, data) {
        state.status       = 'SET_DATA'
        state.data = data
    },
}

const getters = {
    status: state   => state.status,
    data: state => state.data,
    weeklyActiveStores: state => state.data.weekly_active_stores,
    activeStores: state => state.data.active_stores,
    weeklyApprovedConversions: state => state.data.weekly_approved_conversions,
    approvedConversions: state => state.data.approved_conversions,
    activePublishers: state => state.data.active_publishers,
    weeklyActviePublishers: state => state.data.weekly_actvie_publishers,
    balance: state => state.data.balance,
    weeklyBalance: state => state.data.weekly_balance,
    monthlyApprovedConversions: state => state.data.monthly_approved_conversions,
    monthlyRejectedConversions: state => state.data.monthly_rejected_onversions,
}

const actions = {
    setParamsAndFetch({dispatch}, params) {
        dispatch('setParams', params)
        dispatch('fetch')
    },
    setParams({commit}, params) {
        commit('setParams', params)
    },
    fetch({commit}, params) {
        commit('loading')

        return dashboardService.fetch(params).then(response => {
            let result     = response.data

            commit('setData', result.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}